import React, { useEffect } from "react";
import Nav from "../components/site/Nav";
import Hero from "../components/site/Hero";
import DarkChips from "../components/site/DarkChips";
import AccentBlock from "../components/site/AccentBlock";
import SplitCTA from "../components/site/SplitCTA";
import About from "../components/site/About";
import Ideas from "../components/site/Ideas";
import OwnersGift from "../components/site/OwnersGift";
import FAQ from "../components/site/FAQ";
import Footer from "../components/site/Footer";

const Landing = () => {
  useEffect(() => {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("is-visible");
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    document.querySelectorAll(".om-fade-up").forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);

  return (
    <div className="min-h-screen bg-[#FFFDF6] text-[#2b1a20] font-sans-body">
      <Nav />
      <Hero />
      <DarkChips />
      <AccentBlock />
      <SplitCTA />
      <Ideas />
      <FAQ />
      <About />
      <OwnersGift />
      <Footer />
    </div>
  );
};

export default Landing;
